module.exports = __webpack_public_path__ + "static/media/map_logo.236c967e.png";